import React, { useState, useEffect } from 'react'
import API from '../utils/api';
import { useParams } from "react-router-dom";
import Card from 'react-bootstrap/Card';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import PagarCuotaModal from '../Prestamos/PagarCuotaModal'
import { formatearFecha } from '../utils/FormatearFecha';
import ActualizarFechaPagoModal from '../Prestamos/ActualizarFechaPagoModal';
import { Cash, ArrowClockwise } from 'react-bootstrap-icons';
import { Button, Container, Table } from 'react-bootstrap';

const DetallePrestamo = () => {
    const navigate = useNavigate();
    var url = API.urlAPI
    const urlPrestamo = url + "prestamos"
    const urlPrestamoDetalle = url + "prestamodetalle"
    const [modal, setModal] = useState(false);
    const [modalFecha, setModalFecha] = useState(false);
    const [detalle, setDetalle] = useState({});

    const [prestamos, setPrestamos] = useState([]);
    const [prestamosDetalle, setprestamosDetalle] = useState([]);
    const { IdPrestamo } = useParams();

    const getPrestamoDetalle =  () => {
         fetch(
            urlPrestamoDetalle + "/" + IdPrestamo
        )
            .then((r) => r.json())
            .then((prestamosDetalle) => setprestamosDetalle(prestamosDetalle))
        console.log(prestamosDetalle);
        console.log("Se ejecuto Prestamo detalle get")
          
        
    }
    useEffect( ()  => {
        
        const getPrestamo = async () => {
           const {data} = await axios(
                urlPrestamo + "/" + IdPrestamo
            )
              setPrestamos(data)
              setprestamosDetalle(data[0]?.prestamodetalles)
            
        }  
          getPrestamo()
          
     }, [])


    const Navegar = () => {
        navigate("/prestamos/PrestamosActivos");
    }

    const ContainerStyle = {
        boxShadow: '1px 2px 9px white',
        background: 'white'
      };
    
      // Funcion para el modal
      const handleSubmit = (e, item)=>{
        setDetalle(item)
        console.log(detalle)
        setModal(true)
      }
      const handleSubmitFecha = (e, item)=>{
        setDetalle(item)
        console.log(detalle)
        setModalFecha(true)
      }


      const getColor = (estadoFila) => {
        if (estadoFila == "Pago Completo") return '#77dd77';
        if (estadoFila == "Atrasado") return '#ff6961';
        if (estadoFila == "Proximo a vencer") return '#ecab74';
        return '';
      };
      
      useEffect (() => {
        getPrestamoDetalle()
      }, [])
    return (
        <>
        <Container>
        {modal && 
            <PagarCuotaModal 
                modal = {modal}
                setModal = {setModal}
                detalle = {detalle}
                getPrestamoDetalle = {()=>{getPrestamoDetalle()}}
                
                
            ></PagarCuotaModal>
        }
          {modalFecha && 
            <ActualizarFechaPagoModal 
                modalFecha = {modalFecha}
                setModalFecha = {setModalFecha}
                detalle = {detalle}
                getPrestamoDetalle = {()=>{getPrestamoDetalle()}}
                
                
            ></ActualizarFechaPagoModal>
        }

        <div>
            <br></br>
        <Card style={ContainerStyle} >
      <Card.Header style={{ background: "#005187", color:"white"}}><h3>Crédito Cabecera</h3></Card.Header>  
      <Card.Body>
            
            {prestamos.map((item) =>

            <Card>
                
      <Card.Header as="h5" style={{ background: "#74a7e4", color: "white"}}>Crédito N° {item.IdPrestamo} Cliente: {item.Cliente} Fecha: {formatearFecha(item.FechaAlta)} Medio Pago:  {item.medioPago == 'TR' && "Transferencia"} {item.medioPago == 'EF' && "Efectivo"} </Card.Header>
      <Card.Body>   
        <Card.Title>Modalidad {item.Modalidad == '7' && "Semanal"} {item.Modalidad == '31' && "Mensual"} {item.Modalidad == '1' && "Diario"}{item.Modalidad == '15' && "Quincenal"} por un Importe Total de {item.importeTotal}$ a pagar en {item.CantCuotas} Cuotas de {item.ImporteCuota} </Card.Title>
        <Card.Text>
          El cliente contará con {item.DiasdeGracia} días de gracia
        </Card.Text>

     
      </Card.Body>
    </Card>

  
            )}
              </Card.Body>
    </Card>
<br></br>
                
            <br></br>
            <Card style={ContainerStyle} >
      <Card.Header style={{ background: "#005187", color:"white"}}><h3>Crédito Detalle</h3></Card.Header>  
      <Card.Body>
            <br></br>

            <Table responsive >
                <thead  style={{ background: "#74a7e4", color: "white"}}>
                    <tr>
                        <th>Reg Pago</th>
                        <th>Modif. Fecha Pago</th>
                        <th>N° Prestamo</th>
                        <th>Cuota</th>
                        <th>Estado</th>
                        <th>Cuota Original</th>
                        <th>Cuota Con Interes</th>
                        <th>Monto Pago</th>
                        <th>Fecha de Pago</th>
                        <th>Fecha de Vencimiento</th>
                        <th>Registro de Pago</th>
                        <th>Medio de Pago</th>

                    </tr>
                </thead>
                <tbody>
                    {prestamosDetalle.map((item) =>

                        <tr key={item.IdPrestamoDetalle} style={{ background: getColor(item.Estado) }}>
                            <td style={{ minWidth: 100 }}>
                                <Button  variant='success'  disabled = {item.Estado === "Pago Completo"}  onClick={(e)=>handleSubmit(e,item)}><Cash size={25}/></Button>
                        
                            </td>
                            <td style={{ minWidth: 100 }}>
                                <Button  variant='success'  disabled = {item.Estado === "Pago Completo"} onClick={(e)=>handleSubmitFecha(e,item)}><ArrowClockwise size={25}/></Button>
                        
                            </td>
                            <td>{item.IdPrestamo}</td>
                            <td>{item.Cuota}</td>
                            <td>{item.Estado}</td>
                            <td>{item.CuotaOriginal}</td>
                            <td>{item.CoutaConInteres}</td>
                            <td>{item.MontoPago}</td>
                            <td>{formatearFecha(item.FechaPago)}</td>
                            <td>{formatearFecha(item.FechaVencimiento)}</td>
                            
                            <td>{formatearFecha(item.FechaRegistro)}</td>
                            <td>{item.medioPago}</td>

                        </tr>
                    )}
                </tbody>
            </Table>
            </Card.Body>
            </Card>
        </div>
        </Container>
        </>
    )
}

export default DetallePrestamo





